import {RouterModule, Routes} from '@angular/router';
import {NgModule} from "@angular/core";
import {CallbackComponent} from "./callback.component";
import {AuthGuard} from "@auth0/auth0-angular";

export const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'profile',
    loadChildren: async () =>
      (await import('./modules/profile/profile.module')).ProfileModule,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'profile',
  },
  {
    path: '**',
    redirectTo: 'profile'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
